<template>
  <div class="py-12 flex justify-center">
    Verifying Email....
  </div>
</template>
<script>
export default {
  name: 'VerifyEmail',
  async beforeCreate() {
    const response = await this.$store.dispatch('verifyEmail', {
      userToken: this.$route.params.userToken,
      mailToken: this.$route.params.mailToken
    })
    
    this.$notify({
      group: 'buyHive',
      type: response.result ? 'success' : 'error',
      text: response.message,
      duration: 8000
    })
    
    if (this.$store.getters.isUserLoggedIn) {
      this.$router.push({
        name: response.result ? 'AccountReview' : 'Home'
      })
    } else {
      window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}/buy?intent=login&role=freelancer`
    }
  }
} 
</script>
